// import { payload } from "@/schemas/welcome";
import { Request, /* setCookie, */ getCookie } from "../common/util";
import axios from "axios";
/* import Cookies from 'js-cookie' */

/**
 * Register user
 * @param  payload user information object
 */
export const registerUser = (payload) => {
  return Request({
    path: "/auth/register",
    method: "POST",
    data: payload,
  });
};

/**
 * Crate a user profile
 * @param payload user profile information object
 */
export const createUserProfile = (payload) => {
  return Request({
    path: "/users/profiles/create",
    method: "POST",
    data: payload,
  });
};

export const verificationEmail = (payload) => {
  return Request({
    path: `/users/verify-user/${payload.id}`,
    method: "POST",
    data: payload,
  });
};

export const passwordReset = (payload) => {
  return Request({
    path: `/users/memory-lapse/`,
    method: "POST",
    data: payload,
  });
};
/**
 * Authenticate the user
 * @param  payload  user email and password object
 */
export const authenticateUser = (payload) => {
  return Request({
    path: "/auth/login",
    method: "POST",
    data: payload,
  });
};

/**
 *  Create user pdf
 * @param  payload  user token
 */
export const createUserPDF = (payload) => {
  const token = getCookie("token");
  return Request({
    path: "/users/pdf/create",
    method: "POST",
    header: {
      Authorization: token,
    },
    data: payload,
  });
};

/**
 *  Generate zip file for pdfs
 * @param  payload  user token
 */
export const generateZip = (payload) => {
  const token = getCookie("token");
  return Request({
    path: "/users/pdf/zip",
    method: "POST",
    header: {
      Authorization: token,
    },
    data: payload,
  });
};

/**
 * Get authenticated user
 * @param  payload  user token
 */
export const getAuthenticatedUser = (payload) => {
  return Request({
    path: "/users/me",
    method: "GET",
    // data: payload,
    header: {
      Authorization: payload.token,
    },
  });
};

/**
 * Get survey  user
 * @param  payload  user token
 */
export const getSurveyUser = (payload) => {
  return Request({
    path: "/users/survey/me",
    method: "GET",
    // data: payload,
    header: {
      Authorization: payload.token,
    },
  });
};

/**
 * Gets user information
 * @param id number user id
 * @param token string user token
 */
export const getUserInfo = (id, token) => {
  return Request({
    path: `/users/${id}`,
    method: "GET",
    header: {
      Authorization: token,
    },
  });
};

// /**
//  * Upload images to the users home profile
//  * @param {*} payload object with array of images to be uploaded
//  * @returns
//  */
// export const uploadHomeProfileImages = (payload) => {
//     const token = getCookie('token')
//     return Request({
//         path: '/users/home-profile/images',
//         method: 'POST',
//         data: payload,
//         header: {
//             Authorization: token,

//         }
//     })
// }

/**
 * Validates the authenticate user token
 */
export const validateUser = () => {
  const token = getCookie("token");
  return Request({
    path: "/auth/validate",
    method: "POST",
    header: {
      Authorization: token,
    },
  });
};

/**
 * Delete media file
 * @param id  media file id
 */
export const deleteMediaFile = (id) => {
  return Request({
    path: `/users/media/${id}`,
    method: "DELETE",
  });
};

/**
 * Update user profile
 * @param id  user's profile id
 * @param payload  object with profile information to be updated
 */

export const updateUserProfile = (id, payload) => {
  const token = getCookie("token");
  return Request({
    path: `/users/profiles/${id}`,
    method: "POST",
    data: payload,
    header: {
      Authorization: token,
    },
  });
};
/**
 * Update user
 * @param id  user's id
 * @param payload  object with information to be updated
 */

export const updateUser = (id, payload) => {
  const token = getCookie("token");
  return Request({
    path: `/users/${id}`,
    method: "POST",
    data: payload,
    header: {
      Authorization: token,
    },
  });
};

/**
 *
 * @param {*} data object email data
 * @param {*} id  number email template id
 * @returns
 */
export const sendEmail = (data, id) => {
  const token = getCookie("token");
  let formData = new FormData();
  for (const key in data) {
    formData.append(key, data[key]);
  }

  let config = {
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "application/json, text/javascript, */*;q=0.01",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios.post(
    `https://api.sldb.lc/wp-json/contact-form-7/v1/contact-forms/${id}/feedback/`,
    formData,
    config
  );
};

/**
 * Logout user
 *
 */
export const logout = async () => {
  document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  return true;
};
